import { ReportsActionType, IReceiveReportListAction, IReceiveReportListErrorAction, IRequestReportListAction } from './action-types';
import { IReportListResponse } from '../../Interfaces/IReports';

export function requestReportList(): IRequestReportListAction {
  return {
    type: ReportsActionType.REQUEST_REPORT_LIST
  };
}
export function receiveReportList(data: IReportListResponse[]): IReceiveReportListAction {
  return {
    type: ReportsActionType.RECEIVE_REPORT_LIST,
    data: data,
  };
}

export function sendReportListError(errorMessage: string): IReceiveReportListErrorAction {
  return {
    type: ReportsActionType.RECEIVE_REPORT_LIST_ERROR,
    errorMessage,
  };
}
